import { Box, Paper } from "@mui/material";
import back from "../../assets/icons/back.svg";

interface PayPageProps {
  urlIframe: string;
  setUrlIframe: React.Dispatch<React.SetStateAction<string>>;
  setOpenPayPage: React.Dispatch<React.SetStateAction<boolean>>;
}
function PayPage(props: PayPageProps) {
  return (
    <Paper
      sx={{
        pt: 4,
        height: "100vh",
      }}
    >
      <Box
        sx={{ cursor: "pointer", pl: 5 }}
        onClick={() => {
          props.setOpenPayPage(false);
        }}
        component="img"
        src={back}
      ></Box>
      <iframe
        title="iframe"
        style={{
          border: 0,
          width: "100%",
          minHeight: "100%",
        }}
        src={props.urlIframe}
      ></iframe>
    </Paper>
  );
}

export default PayPage;
